module.exports = __webpack_public_path__ + "img/signup-carousel-first@2x.acd39289.png";